import { useApolloClient } from '@apollo/client';
import UserDataQuery from './UserDataQuery';
import { formatIsoDate } from '../../Helpers/dateFormatter';

const UserDataConnectorApollo = ({ children }) => {
  const client = useApolloClient();

  const fetch = async () => {
    try {
      const date = formatIsoDate(new Date());

      const result = await client.query({
        query: UserDataQuery,
        variables: { date },
        fetchPolicy: 'network-only',
      });

      const email = result?.data?.me?.email ?? '';
      const id = result?.data?.me?.id ?? '';
      const systemOfMeasures = result?.data?.me?.systemOfMeasures ?? 'si';
      localStorage.setItem('userEmail', email);
      localStorage.setItem('userId', id);
      localStorage.setItem('systemOfMeasures', systemOfMeasures);
      localStorage.setItem('userCreated', result?.data?.me?.created ?? '');

      // check if user has access to diet and ai
      const todayDateString = new Date().toISOString().slice(0, 10);
      const dietAccessTo = result?.data?.me?.diet?.accessTo;
      const hasDietAccess = Boolean(dietAccessTo) && dietAccessTo >= todayDateString;

      const aiAccess = result?.data?.me?.aiAccess?.hasAccess;
      const dietAccess = hasDietAccess;

      sessionStorage.setItem('aiAccess', aiAccess ? 'true' : 'false');
      sessionStorage.setItem('dietAccess', dietAccess ? 'true' : 'false');

      return result;
    } catch (err) {
      console.error('Failed to fetch user data', err);
      throw err;
    }
  };

  return children({
    userDataOnDemand: fetch,
  });
};

export default UserDataConnectorApollo;
